import React, { useEffect } from "react";
import CounterpartyPage from '../../../Counterparty'
import { useDispatch, useSelector } from "react-redux";
import { setCounterpartyDetails, setCounterpartyLoading, setCounterpartyError } from "../../../../../store/reducers/slices/counterparty.slice";
import { getCounterparty } from "../../../../../api/Counterparty";

const Counterparty = ({onClickTabChange = () => { }}) => {

    const dispatch = useDispatch();
    const { counterpartyDetails } = useSelector(({ counterparty }) => counterparty);
    const { reportDetails, selectedAccountId } = useSelector(({ reportDetails }) => reportDetails);

    // API and redux
    useEffect(() => {
        // dispatch(setCounterpartyLoading(true));
        const fetchData = async () => {
            try {
                let aggregate = selectedAccountId !== 'all'? false : true;
                let account_id = selectedAccountId !== 'all'? selectedAccountId : reportDetails?.report?.reportId;
                const response = await getCounterparty(account_id, aggregate);
                console.log("DATA:", response);

                dispatch(setCounterpartyDetails(response));
                dispatch(setCounterpartyLoading(false));
            } catch (error) {
                dispatch(setCounterpartyLoading(false));
                dispatch(setCounterpartyError(error.message));
                console.log("ERROR", error);
            }
        }

        if (selectedAccountId) {
            dispatch(setCounterpartyLoading(true));
            fetchData();
        }
        // else {
        //     dispatch(setCounterpartyLoading(false));
        // }
    }, [selectedAccountId])

    return (
        <CounterpartyPage onClickTabChange={onClickTabChange} />
    )
}

export default Counterparty